import type { FunctionComponent } from 'react'
import { DesignSystem } from '@/src/design-system'
import { useCardApplicationPlatform } from '../hooks/useCardApplicationPlatform'
import { Redirect } from 'expo-router'
import { Screens } from '..'

export function withCardPlatform<TProps extends Record<string, unknown>>(
  PlatformScreen: FunctionComponent<TProps>,
  HighnoteLegacyScreen: FunctionComponent<TProps>,
) {
  const WrappedComponent = (props: TProps) => {
    const platform = useCardApplicationPlatform()

    switch (platform) {
      case 'LOADING':
        return <DesignSystem.Loading.Screen />
      case 'ERROR':
        return <Screens.GenericErrorScreen />
      case 'APPLICATIONS_DISABLED':
        // If applications are disabled, redirect the user back to the card benefits screen
        return <Redirect href="/main/(tabs)/card-benefits" />
      case 'HIGHNOTE':
        return <HighnoteLegacyScreen {...props} />
      default:
        return <PlatformScreen {...props} />
    }
  }

  WrappedComponent.displayName = `withCardPlatform(${
    PlatformScreen.displayName || PlatformScreen.name || 'Component'
  })`

  return WrappedComponent
}
